import { useState } from 'react';
import { Center, Container, FormField, FormGroup, Input, Textarea } from '../../../components/Form';
import './style.css';
import PanelLayout from '../../panelComponents/PanelLayout/PanelLayout';
import { Button } from '../../../components/Button';
import { useDispatch } from 'react-redux';
import { addTemplate } from '../../../store/userSlice';
import { toastError, toastSuccess } from '../../../BTUI/BtToast';
import { useNavigate } from 'react-router-dom';

const AddTemplate = () => {
    const [payload, setPayload] = useState({})
    const [error, setError] = useState({});
    const dispatch = useDispatch()
    const navigate = useNavigate()


    const handleChange = (name, value) => {
        setPayload({
            ...payload,
            [name]: value
        })
        console.log(name, value)
        setError({
            ...error,
            [name]: null
        })
    }

    const handleSubmit = () => {
        dispatch(addTemplate(payload))
        .then((res) => {
            console.log("Template ",res)
            setPayload("")
            toastSuccess(res?.data?.message)
            navigate('/executive/template/list')
        })
        .catch((err) => {
            console.error(err)
            if(err?.data?.field_errors?.code){
                toastError(err?.data?.field_errors?.code)
            }else{
                toastError(err?.data?.message)
            }
            console.log("error length",err?.data?.field_errors?.code)
        });
    }


    return <PanelLayout>
                <h1 style={{textAlign: 'center', marginBottom: '1em'}}>Add New Template</h1>
            <Container>
                {/* <div className=""> */}
                    <FormGroup>
                        <FormField>
                            <Input 
                                label="Code"
                                name="code"
                                value={payload?.code}
                                error={error?.code}
                                handleChange={handleChange}
                            />
                        </FormField>
                        <FormField>
                            <Input 
                                label="Title"
                                name="title"
                                value={payload?.title}
                                error={error?.title}
                                handleChange={handleChange}
                            />
                        </FormField>
                        <FormField>
                            <Textarea 
                                label="Descrption"
                                name="description"
                                rows="10"
                                value={payload?.description}
                                error={error?.description}
                                handleChange={handleChange}

                            />
                        </FormField>
                    </FormGroup>
                    <br/>
                {/* </div> */}
                <Center>
                    <Button title="Add Template" onClick={handleSubmit} />
                </Center>
            </Container>
            
    </PanelLayout>
}

export default AddTemplate